import db from "../db";
import Constants from "../constants";
import * as Helpers from "../helpers";
import Vuex from "vuex";

export default {
  data() {
    return {
      processing: false,
      action: false,
      offertaCustom: 1,
    };
  },
  methods: {
    squadra(id) {
      return this.asta_squadre[id];
    },
    setRilancio(rilancio) {
      this.dismissPokerAction && this.dismissPokerAction();
      let offerta = this.migliore_offerta.offerta + rilancio;
      this.setOfferta(offerta);
    },
    setPasso() {
      this.dismissPokerAction && this.dismissPokerAction();
      this.setOfferta(Constants.OFFERTA.PASSO);
    },
    setOffertaCustom(val) {
      this.dismissPokerAction && this.dismissPokerAction();
      this.setOfferta(val);
    },
    setOfferta(val) {
      if (this.processing) {
        return;
      }
      this.processing = true;

      this.action = true;
      db.setOfferta(val, true, false)
        .then(() => {
          this.processing = false;
        })
        .catch((e) => {
          console.log(e);
          this.processing = false;
        });
    },
    showNumpad() {
      db.emit("numpad", true);
    },
    hideNumpad() {
      db.emit("numpad", false);
    },
  },
  computed: {
    canPokerAct() {
      return (
        this.mode_poker &&
        this.running &&
        this.asta_round.speaker == this.user_uid &&
        this.migliore_offerta.vincitore != this.user_uid &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined
      );
    },
    pokerCannotJoinReason() {
      if (
        !this.mode_poker ||
        !this.asta_info ||
        !this.asta_info.lega ||
        !this.squadra(this.user_uid) ||
        this.calciatoreInAsta === null ||
        this.calciatoreInAsta === undefined
      ) {
        return null;
      }

      return Helpers.canJoinRoundWithReason(
        this.asta_info.lega,
        this.squadra(this.user_uid),
        this.calciatore(this.calciatoreInAsta),
        this.minOfferta
      ).reason;
    },
    pokerPassoText() {
      return this.pokerCannotJoinReason || "Hai passato";
    },
    showPokerPassoHint() {
      return (
        this.mode_poker &&
        this.running &&
        this.squadra(this.user_uid) &&
        this.squadra(this.user_uid).active &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined &&
        this.asta_round.offerte &&
        this.asta_round.offerte[this.user_uid] === Constants.OFFERTA.PASSO
      );
    },
    maxRilancio() {
      return Math.min(
        Constants.OFFERTA.RILANCIO,
        this.squadra(this.user_uid)
          ? this.squadra(this.user_uid).max_offerta -
              this.migliore_offerta.offerta
          : Constants.OFFERTA.MINIMA
      );
    },
    maxOfferta() {
      return this.squadra(this.user_uid)
        ? this.squadra(this.user_uid).max_offerta
        : Constants.OFFERTA.MINIMA;
    },
    minOfferta() {
      return this.migliore_offerta.vincitore
        ? this.migliore_offerta.offerta + Constants.OFFERTA.MINIMA
        : Helpers.minOfferta(
            this.asta_settings.base_asta,
            this.calciatore(this.calciatoreInAsta)
          );
    },
    ruolo_abc() {
      if (this.calciatoreInAsta != null) {
        return Constants.RUOLI_NEW[
          this.calciatori[this.calciatoreInAsta].ID_Ruolo
        ].abc;
      }
      return null;
    },
    ...Vuex.mapGetters(["migliore_offerta", "myPlan"]),
  },
};
